import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';

import "babel-polyfill";
import "function.name-polyfill";
import {runWithAdal} from 'react-adal';
import {authContext} from './adalConfig';

import App from "./containers/App/App";

import "./assets/sass/style.scss";

window.init_react = function(config) {
  window.djconfig = config;
  runWithAdal(authContext, () => {
    //ReactDOM.render(<App />, document.getElementById("root"));
    const container = document.getElementById('root');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<App tab="home" />);
  });
};
